<!-- eslint-disable vue/multi-word-component-names -->
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import QuestionAnswer from '/src/components/QuestionAnswer.vue'
import QuestionPage from '/src/components/QuestionPage.vue'
import { MDBBtn} from "mdb-vue-ui-kit";
import { mapFields } from 'vuex-map-fields';

export default {
  components: {
    QuestionAnswer,
    QuestionPage,
    MDBBtn,
  },
  computed: {
    ...mapFields([
      'scene.status.personal'
    ]),
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('personal')
    }
  },
  methods: {
    ...mapMutations([
      'selectPersonalStatus',
      'goToNextPage',
      'moveToItem'
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectPersonalStatus(1);
      this.personal = 1
    },
    chooseMedium: function () {
      this.selectPersonalStatus(2);
      this.personal = 2
    },
    chooseTop: function () {
      this.selectPersonalStatus(3);
      this.personal = 3
    }
  },
};
</script>

<template>
  <QuestionPage :title="questionAnswerData.question">
    <Transition name="switch" mode="out-in" appear>
      <div v-if="personal < 2"
        class="question_image question_image_personal-basic d-block d-sm-none"
      ></div>
      <div v-else-if="personal == 2"
        class="question_image question_image_personal-medium d-block d-sm-none"
      ></div>
      <div v-else-if="personal == 3"
        class="question_image question_image_personal-top d-block d-sm-none"
      ></div>
    </Transition>

    <!-- show on desktop only -->
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='d-none d-sm-block'
      :onSelect="chooseBasic"
      @click="goToItem('personal')"
      :imageName="questionAnswerData.images.Q9AA"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='d-none d-sm-block'
      :onSelect="chooseMedium"
      @click="goToItem('personal')"
      :imageName="questionAnswerData.images.Q9AB"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='d-none d-sm-block'
      :onSelect="chooseTop"
      @click="goToItem('personal')"
      :imageName="questionAnswerData.images.Q9AC"
    />

    <!-- on mobile only -->
    <div class='d-flex d-sm-none questions-on-mobile questions-on-mobile--adjusted-spacing'>
      <QuestionAnswer
        :title="questionAnswerData.answers.A"
        class='answer-personal-basic'
        :onSelect="chooseBasic"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.B"
        class='answer-personal-medium'
        :onSelect="chooseMedium"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.C"
        class='answer-personal-top'
        :onSelect="chooseTop"
      />
      <MDBBtn class="next-btn-on-mobile next-btn-on-mobile--adjusted-spacing" @click="moveToItem('personal')">next</MDBBtn>
    </div>
  </QuestionPage>
</template>


